import { createRouter, createWebHistory, RouterView } from 'vue-router'
import Home from '@/views/Home'
import Film from '@/views/Film'
import Chefs from '@/views/Chefs'
import Recipe from '@/views/Recipe'
import PageNotFound from '@/views/PageNotFound'

import Cookies from 'js-cookie'

import i18n from '@/i18n/i18n'
import Tr from "@/i18n/translation"

// const routes = [
//   {
//     path: "/:locale?",
//     component: RouterView,
//     beforeEnter: Tr.routeMiddleware,
//     children: [
//       {
//         path: '',
//         name: 'home',
//         component: Home
//       },
//       {
//         path: '/:locale/test',
//         name: 'homeTest',
//         component: Home
//       },
//       { 
//         path: "/:pathMatch(.*)*",
//         component: PageNotFound
//       }
//     ]
//   }
// ]

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/film',
    name: 'Film',
    component: Film
  },
  {
    path: '/chefs',
    name: 'Chefs',
    component: Chefs
  },
  {
    path: '/recipe/:slug',
    name: 'Recipe',
    component: Recipe,
    beforeEnter: (to, from, next) => {
      function isValid (param) {
          return Object.keys(i18n.global.messages[i18n.global.locale].recipes)?.indexOf(param) > -1
      }
      if (!isValid(to.params.slug)) {
        next({ name: 'Notfound' });
      }
      next();
    }
  },
  { 
    path: "/:pathMatch(.*)*",
    name: 'Notfound',
    component: PageNotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (Cookies.get('krug-age-gate') !== 'ok' && !to.params.ageGate) next({ name: to.name, params: { ageGate: true } })
  else next();
})

export default router
